import React from 'react'; 
import { BrowserRouter as Router } from 'react-router-dom';
import '../../CSS/Dashboard/dashboard.scss';
import DashboardNavbar from './Components/DashboardNavbar';
import Sidenav from './Components/Sidenav';
const Dashboard = ({children})=> { 
  return (
    <div>
    <div className="navbar-content">
      <DashboardNavbar/>
    </div>
    <div className="dashboard-content">
      <div className="dashboard-sidenav">
        <Sidenav/>
      </div>
      <div className="dashboard">
        <div className="container-fluid">
          <div className="row mt-5 ml-5">
            <div className="col-md-12">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Dashboard; 